<ng-container *ngIf="items">

  <div class="d-flex flex-row pt-3 pb-3">
    <span style="width: 75%"></span>
    <span style="width: 25%">
      <button class="btn btn-sm text-white"
              type="button"
              style="width: 100%"
              (click)="selectAll()"
              *ngIf="!selectAllMode"
              [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">Seleccionar Todo</button>
      <button class="btn btn-sm text-white"
              type="button"
              style="width: 100%"
              (click)="deSelectAll()"
              *ngIf="selectAllMode"
              [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">Deseleccionar todo</button>

    </span>
  </div>

  <div class="d-flex flex-row card mt-2 justify-content-between" *ngFor="let item of items, let i = index"
    [ngStyle]="{'border': item.selected ? '2px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : '2px solid #cac6c6'}"
     style="padding-bottom: .5em; padding-top: .5em;">
    <div class="d-flex data-item">
      <div class="d-flex content-icon justify-content-center">

        <div class="d-flex icon-item align-items-start justify-content-between" style="position: relative;">
          <span class="circle-icons">
            <img
                                  *ngIf="item.categoryName == 'HOTELS'"
                                  width="25"
                                  src="../../../assets/icons/itinerary/bed-svgrepo-com.svg"
                                  alt="">

                              <img
                                *ngIf="item.categoryName == 'RENT-A-CAR'"
                                width="25"
                                src="../../../assets/img/app/icon-car-black.svg"
                                alt=""
                              />

                              <img
                                *ngIf="item.categoryName == 'TRANSPORTS'"
                                width="25"
                                src=".../../../assets/icons/itinerary/school_15476203.svg"
                                alt=""
                              />

                              <img
                                *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 6"
                                width="25"
                                src="../../../assets/img/app/road-map.svg"
                                alt=""
                              />
                              <img
                                *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 9"
                                width="25"
                                src="../../../assets/img/app/categories-search-box/combi-ticket.svg"
                                alt=""
                              />
                              <img
                                *ngIf="item.categoryName == 'INSURANCE'"
                                width="25"
                                src="../../../assets/img/app/categories-search-box/icon-seguro.svg"
                                alt=""
                              />
          </span>
        </div>




        <!-- <div class="d-flex circle align-items-center justify-content-center"
          [ngClass]="{'green-background': item.status_id != 5, 'red-background': item.status_id == 5}">
          <i class="icons-hotel" *ngIf="item.categoryName=='HOTELS'"></i>
          <i class="icons-adventure" *ngIf="item.categoryName=='TOURS'"></i>
          <i class="icons-transporte" *ngIf="item.categoryName=='TRANSPORTS'"></i>
          <i class="icons-car" *ngIf="item.categoryName=='RENT-A-CAR'"></i>
          <i class="icon-small icon-pthemes iconstart text-center pl-1" style="font-size: 25px;"
            *ngIf="item.categoryName=='PTHEMES'"></i>
          <i class="icon-small icon-seguro iconstart text-center pl-1" style="font-size: 25px;"
            *ngIf="item.categoryName=='INSURANCE'"></i>
          <i class="icon-small icon-crucero iconstart text-center pl-1" style="font-size: 25px;"
            *ngIf="item.categoryName=='CRUISES'"></i>
          <i class="icon-small icon-disney iconstart text-center pl-1" style="font-size: 25px;"
            *ngIf="item.categoryName=='DISNEY'"></i>
        </div> -->
      </div>
      <div class="d-flex flex-column title-item">
        <div class="d-flex mb-2" style="margin-left: 5px;">
          <h5 class="font-poppins m-0">{{stingUpperCase(item.title)}}</h5>
        </div>
        <div class="d-flex mb-2 pl-1">
          <p class="font-poppins m-0">
            <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
            <!-- <i class="icon-placeholder placeholder" aria-hidden="true"></i> -->
            &nbsp;&nbsp;{{item.destination.iata_code}}
          </p>
        </div>
        <div class="d-flex flex-row justify-content-start">
          <img _ngcontent-c35="" alt="" class="img-fluid icon-premium-point" src="/assets/img/app/little-icons/badge-bks.png">
          <p _ngcontent-c35="" class="font-point text-left f-16 m-0 pt-2">&nbsp; {{item.blickoins}} Bks.</p>
        </div>
      </div>
      <!-- <div class="d-flex stars-item">
        <bar-rating [(rate)]="rate" [max]="5" [theme]="'fontawesome'" class="ml-auto stars" [readOnly]="true">
        </bar-rating>
      </div> -->
      <div class="d-flex flex-column ml-auto status-item justify-content-between">
        <div class="d-flex align-self-center">
          <div class="state" [ngClass]="{
              'product-status-saved': item.status_id == 1,
              'product-status-reserved': item.status_id == 2,
              'product-status-locked': item.status_id == 3,
              'product-status-denied': item.status_id == 4,
              'product-status-cancelled': item.status_id == 5,
              'product-status-paid-agency': item.status_id == 6,
              'product-status-paid-provider': item.status_id == 7,
              'product-status-billed': item.status_id == 8,
              'product-status-pending-approve-pay': item.status_id == 9,
              'product-status-completed': item.status_id == 10 }"
          >
            <p class="text-status m-0">
              {{ item.status }}
            </p>
          </div>
        </div>
        <div *ngIf="item?.cancellation_policy && item?.cancellation_policy[0]?.from" class="d-flex align-self-center">
          <p class="text-expiration m-0 p-0">Día de expiración <br> <span
              class="date-expiration">{{ item.cancellation_policy[0]?.from | date : "dd/MM/yyyy" }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex price-item flex-column justify-content-between align-self-center">
      <div class="d-flex rows-price" style="justify-content: center;">
        <p class="font-poppins m-0 p-0 text-price">TARIFA NETA</p>
      </div>
      <div class="d-flex rows-price mb-2" style="justify-content: center;">
        <p class="font-poppins m-0 p-0 nro-price" style="text-align: center;">
           {{currencyAgency.code}} {{ getPrice(item)
                                      | currencyConverterPure:
                                        item.currency:
                                        currencyAgency.code:
                                        currencies
                                      | number: '1.2-2'}}
        </p>
         <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="getClientsSettingAppBooking"
            [currencyProduct]="item.currency"
            [valueProduct]="getPrice(item)">
          </usb-tooltip-convert-amount>
      </div>

      <div *ngIf="getPaymentOffice(item)" class="d-flex rows-price" style="justify-content: center;">
        <p class="font-poppins m-0 p-0  text-price">Pago en oficina</p>
      </div>
      <div *ngIf="getPaymentOffice(item)" class="d-flex rows-price" style="justify-content: center;">
        <p class="font-poppins m-0 p-0 nro-price" style="text-align: center;">
             {{currencyAgency?.code}} {{ getSumPaymentOffice(item)
                                      | currencyConverterPure:
                                        item.currency:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
        </p>
         <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="getClientsSettingAppBooking"
            [currencyProduct]="item.currency"
            [valueProduct]="getSumPaymentOffice(item)">
          </usb-tooltip-convert-amount>
      </div>

      <div *ngIf="item.fee > 0 && !item.feePayment" class="d-flex rows-price" style="justify-content: center;">
        <p class="font-poppins m-0 p-0  text-price">FEE</p>
      </div>
      <div *ngIf="item.fee > 0 && !item.feePayment" class="d-flex rows-price" style="justify-content: center;">
        <p class="font-poppins m-0 p-0 nro-price" style="text-align: center;">
          <!-- {{currencyItinerary}} {{item.fee | number:'1.2-2'}} -->
             {{currencyAgency?.code}} {{ item.fee
                                      | currencyConverterPure:
                                        item.currency:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
        </p>
        <p class="ml-1" style="color: red; font-size: 24px; line-height: 1;">*</p>
         <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="getClientsSettingAppBooking"
            [currencyProduct]="item.currency"
            [valueProduct]="item.fee">
          </usb-tooltip-convert-amount>
      </div>

      <div class="d-flex rows-price flex-column mt-auto" >
        <p class="font-poppins text-select m-0 p-0 mt-2" style="text-align: center;">Seleccionar</p>
        <span class="mb-0 mt-1" style="margin: 0 auto;">
          <label class="custom-radio-checkbox mb-0">
            <input class="custom-radio-checkbox__input" [id]="i" type="checkbox" [name]="i" (change)="addItem(item, i)" [(ngModel)]="item.selected">
            <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
          </label>
        </span>
      </div>

    </div>
  </div>
</ng-container>


<!-- <button class="btn btn-primary" (click)="goStepTwo()">
  Next
</button> -->
